module.exports = __webpack_public_path__ + "static/Solar-Outdoor-Light-8a7e8d0de8d10f68a9c4a0fc95e13a9d.jpg";